













import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ChildComponentMixin from '@/common/ts/child-component/ChildComponentMixin';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

const SubFooterSectionsItemProps = Vue.extend({
  props: {
    linkUrl: String,
    linkText: String,
    linkTarget: String,
  },
});

@Component
export default class SubFooterSectionsItem extends mixins(SubFooterSectionsItemProps, ChildComponentMixin) {
  parentIndex = -1;

  created () {
    this.initChildComponentMixin('SubFooterSectionsItem');
  }

  onItemClick (): void {
    if (this.linkUrl) {
      const link = this.linkUrl;
      const label = this.linkText;
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Footer Section', label, link);
    }
  }

  onFocusIn () {
    this.$el.dispatchEvent(new CustomEvent(
      'footerSectionsItemFocused',
      {
        bubbles: true,
        composed: true,
        detail: {
          item: this,
        },
      },
    ));
  }
}
